// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__36dzq","alertIcon":"ConfirmModal_alertIcon__3WS9t"};